import React, {useContext} from 'react';
import {FormContext} from "./MDForm";
import {propsToCSS} from "../css";
import {BASIC_ELEMENT_SCHEMA, Group} from "../layout/Group";
import {merge} from "lodash";
import {getOptionsForAttr, globalListLookup, productListLookup} from "../fields/coderefs";
import {ProductInfoContext} from "../data/ApplicationDataSource";
import {stringToUIString} from "../../utils/dateUtils";
import { formatMoneyAmount } from '../../utils/formatUtils';
import { GlobalStateContext } from '../../context/GlobalStateProvider';


export function Data({path, attr, dataType, remapUsingGlobalList, remapUsingProductList, ...props}) {

  if (!path && !attr) {
    return null;
  }


  const formContext = useContext(FormContext);
  const { hideNavLabels } = useContext(GlobalStateContext);
  const {productSetup: {productList}, codeRefs} = useContext(ProductInfoContext);

  let value;

  if (path) {
    value = formContext.getValue(path)
  }

  if (attr) {
    value = formContext.getValueByAttr(attr);
  }

  if (path === 'basicPolicy.writtenPremiumAmt') {
    value = parseInt(value) + parseInt(formContext.getValue('basicPolicy.writtenFeeAmt'));
  }

  if (dataType === 'Date') {

    value = stringToUIString(value)

  } else if (dataType === 'Money') {
    const newValue = formatMoneyAmount(parseFloat(value));
    value = newValue;
  } else {
    let options;
    if (remapUsingGlobalList) {
      options = globalListLookup(codeRefs, remapUsingGlobalList)
    } else if (remapUsingProductList) {
      options = productListLookup(productList, remapUsingProduct);
    }
    if (options) {
      value = options.index[value] || value;
    }
  }

  return <span style={{fontSize: hideNavLabels ? '16px' : ''}} {...propsToCSS(props)}>{value}</span>;
}

Data.schema = merge({
  properties: {
    path: {
      type: 'string',
    },
    attr: {
      type: 'string',
    },
    dataType: {
      type: 'string',
    },
    remapUsingGlobalList: {
      type: 'string',
    },
    remapUsingProductList: {
      type: 'string',
    },
  }
}, BASIC_ELEMENT_SCHEMA);